export default __webpack_public_path__ + "static/jamie-3c530ad847b831e81ea657374331aaf9.jpg";